import React, { createContext, useContext, useState, useEffect } from 'react';
import { BusinessUnit, Store } from '@/types/entity/business-unit';
import { BusinessUnit as GWBusinessUnit } from "@shared/types/business-unit";
import { ContextShape } from './types';
import { mapBusinessUnit } from '@/utils/mappers/map-business-unit';
import { mapStore } from '@/utils/mappers/map-store';
import { BUSINESS_UNIT_POSTAL_CODE } from '@/constants/generic';
import { sdk } from '@/sdk/CommercetoolsSDK';
import businessUnitService from '@/service/business-unit/business-unit.service';

const initialState = {} as ContextShape;
export const StoreAndBusinessUnitsContext = createContext(initialState);

const StoreAndBusinessUnitsProvider = ({ children }: React.PropsWithChildren) => {
  const [selectedBusinessUnits, setSelectedBusinessUnits] = useState<BusinessUnit>();
  const [selectedStore, setSelectedStore] = useState<Store>();
  const companyChain = selectedBusinessUnits?.company_chain ?? '';
  const chooseBusinessUnit = (bu: GWBusinessUnit) => {
    setSelectedBusinessUnits(mapBusinessUnit(bu));
    localStorage.setItem('business-unit', bu.key ?? '');
    const postalCode = bu.addresses?.[0]?.postalCode;
    localStorage.setItem(BUSINESS_UNIT_POSTAL_CODE, postalCode ? postalCode.toString() : '');
    const defaultBuStore = bu.stores?.[0];
    if (defaultBuStore) {
      setSelectedStore(mapStore(defaultBuStore));
      const newStoreKey = defaultBuStore.key ?? '';
      localStorage.setItem('store', newStoreKey);
    }
  }

  useEffect(() => {
    if (companyChain) {
      businessUnitService.selectCompany(companyChain);
    }
  }, [companyChain]);

  return (
    <StoreAndBusinessUnitsContext.Provider
      value={{
        selectedBusinessUnit: selectedBusinessUnits,
        setSelectedBusinessUnit: setSelectedBusinessUnits,
        selectedStore,
        setSelectedStore,
        chooseBusinessUnit,
      }}
    >
      {children}
    </StoreAndBusinessUnitsContext.Provider>
  );
};
export default StoreAndBusinessUnitsProvider;
export const useStoreAndBusinessUnits = () => useContext(StoreAndBusinessUnitsContext);
